import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import StatesStats from '../../components/StatesStats';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'State Name',
      attr: 'name',
      disableSort: true
    },
  ];

  return <>

    <ListingPageComponent
      key={PAGES.StatesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.StatesListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'States' }]}
      listingMutation={getApi('states')}
      className="states-listing-page"
      contentHeading="All States - Results"
      headers={headers}
      recordsKey="states"
      contentTop={<StatesStats />}
      searchBy={['State Name']}
    />
  </>
};

export default Index;
